import {
  Box,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import React from "react";

const HEADERS = ["Column", "Invalid Value", "Reason"];

export const ColumnsBlock = ({ data }) => {
  const { valid_columns, unrecognized_columns, invalid_columns } = data || {};

  return (
    <Stack gap="10px">
      {!!valid_columns && (
        <Typography>
          <Box component="span" fontWeight={600}>
            Valid columns:
          </Box>{" "}
          {valid_columns}
        </Typography>
      )}

      {!!unrecognized_columns && (
        <Typography>
          <Box component="span" fontWeight={600}>
            Unrecognized columns:
          </Box>{" "}
          {unrecognized_columns}
        </Typography>
      )}

      {!!invalid_columns && !!Object.keys(invalid_columns)?.length && (
        <Stack gap="5px">
          <Typography fontWeight={600}>Invalid columns:</Typography>
          <TableContainer
            component={Paper}
            sx={{
              boxShadow: "none",
              boxSizing: "border-box",
              maxHeight: "266px",
              border: "1px solid rgb(233, 236, 239)",
              borderRadius: "6px",
            }}
          >
            <Table stickyHeader sx={{ width: "100%" }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  {HEADERS.map((header) => (
                    <TableCell
                      key={`header:${header}`}
                      sx={{
                        fontFamily: "Inter",
                        fontWeight: 600,
                        color: "#101828",
                        minWidth: "150px",
                        lineHeight: "19px",
                        background: "linear-gradient(0deg, #FAFBFB, #FAFBFB)",
                        borderColor: "#F2F4F7",
                      }}
                    >
                      {header}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {Object.entries(invalid_columns).flatMap(([variable, { invalid_values }]) =>
                  Object.entries(invalid_values).map(([value, errorMessage], index) => (
                    <TableRow hover key={`${variable}-${value}`}>
                      <TableCell align="left">{index === 0 ? variable : ""}</TableCell>
                      <TableCell>{value}</TableCell>
                      <TableCell>{errorMessage}</TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Stack>
      )}
    </Stack>
  );
};
